"use client";

import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "./firebase";

const viteEnv = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env;

export const protectedDispatchConfigured = viteEnv?.VITE_PROTECTED_DISPATCH_ENABLED === "true";

const functions = getFunctions(firebaseApp, "asia-south1");

const phonePattern = /(?:\+?91[\s-]?)?[6-9](?:[\s-]?\d){9}\b/i;
const emailOrUpiPattern = /\b[a-z0-9._%+-]+@[a-z0-9.-]+\b/i;
const urlPattern = /(?:https?:\/\/|www\.|\b[a-z0-9-]+\.(?:com|in|net|org)\b)/i;
const offPlatformPattern = /\b(?:whats?app|telegram|call\s+me|contact\s+me|pay\s+(?:me\s+)?direct(?:ly)?|outside\s+(?:the\s+)?app)\b/i;

export function messageHasContactLeak(text: string) {
  const normalized = text.normalize("NFKC");
  return phonePattern.test(normalized)
    || emailOrUpiPattern.test(normalized)
    || urlPattern.test(normalized)
    || offPlatformPattern.test(normalized);
}

export async function sendProtectedMessage(requestId: string, text: string) {
  if (messageHasContactLeak(text)) {
    throw new Error("Keep phone, email, UPI and links inside the protected booking flow.");
  }
  const callable = httpsCallable<{ requestId: string; text: string }, { messageId: string }>(
    functions,
    "sendProtectedMessage",
  );
  return (await callable({ requestId, text })).data;
}

export async function confirmAssignedPartner(requestId: string) {
  const callable = httpsCallable<{ requestId: string }, { confirmed: true; partnerId: string }>(
    functions,
    "confirmAssignedPartner",
  );
  return (await callable({ requestId })).data;
}

export async function getRelayContact(requestId: string) {
  const callable = httpsCallable<{ requestId: string }, { relayPhone: string | null }>(
    functions,
    "getRelayContact",
  );
  return (await callable({ requestId })).data.relayPhone;
}
